<template>
  <div class="backdrop" v-if="isShow && isMain && newPosts.length > 0">
    <div class="popup-main" v-if="isShow && isMain">
      <div class="popup-con">
        <swiper
          :loop="true"
          :speed="1000"
          :navigation="false"
          :modules="[Thumbs, Navigation, Autoplay, Pagination]"
          :autoplay="{
            delay: 3000,
            disableOnInteraction: false,
          }"
          :pagination="{
            clickable: true,
            el: '.swiper-pagination',
          }"
          @swiper="onSwiper"
        >
          <swiper-slide
            class="swiper-slide"
            v-for="(banner, idx) in newPosts"
            :key="idx"
          >
            <!--슬라이드 영역-->
            <component
              :is="banner?.priorUrl?.length > 1 ? 'a' : 'router-link'"
              :href="banner?.priorUrl?.length > 1 ? banner?.priorUrl : null"
              :to="
                banner?.priorUrl > 1
                  ? null
                  : {
                      name: ROUTE_NAME.NewsView,
                      params: {
                        type: banner.boardId == 'news' ? 0 : 1,
                        subType: 0,
                        postId: banner.id,
                        viewType: 'view',
                      },
                    }
              "
              style="cursor: pointer"
            >
              <div class="img-slider">
                <img
                  :src="
                    banner?.twPostImages?.find(
                      (it: any) => it.hpImageDiv === 'THUMBNAIL'
                    )?.twImage?.url ??
                    '/src/infrastructure/assets/img/contents/notice-test.jpg'
                  "
                  :alt="banner"
                />
              </div>
            </component>
          </swiper-slide>
          <div class="swiper-pagination"></div>
        </swiper>
      </div>
      <div class="btn-popup">
        <span>
          <button
            id="dont-show-not-today"
            class="cursor"
            @click="handleNotShowToday"
          >
            오늘 하루 그만 보기
          </button>
        </span>
        <button
          class="btn-pop-close"
          aria-label="Close"
          @click="handleClosePopup"
        >
          닫기 <img src="@assets/img/pop_close.svg" alt="닫기" />
        </button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref, watch } from 'vue';
import { RouteLocationNormalized, useRouter } from 'vue-router';
import { ROUTE_NAME } from '@constants';
import { useNewMainBoards } from '@infra/composables';
import { Autoplay, Navigation, Pagination, Thumbs } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Swiper as SwiperClass } from 'swiper/types';

const newPosts = ref<any[]>([]);
const isShow = ref(true);
const isMain = ref(false);

const router = useRouter();

const { handleFetchNewMainBoards } = useNewMainBoards();

const handleClosePopup = () => {
  isShow.value = false;
};

const swiperInstance = ref<SwiperClass>();
const onSwiper = (swiper: SwiperClass) => {
  swiperInstance.value = swiper;
};

const checkDoNotShow = () => {
  const doNotShowDate = localStorage.getItem('doNotShowDate');
  const today = new Date().toDateString();

  if (doNotShowDate === today) {
    isShow.value = false;
  }
};

const handleNotShowToday = () => {
  const today = new Date().toDateString();
  isShow.value = false;
  localStorage.setItem('doNotShowDate', today);
};

watch(router.currentRoute, (value: RouteLocationNormalized) => {
  isMain.value = value.name === ROUTE_NAME.Main;
});

onMounted(async () => {
  isMain.value = router.currentRoute.value.name === ROUTE_NAME.Main;
  checkDoNotShow();
  const postsData: any = await handleFetchNewMainBoards({
    limit: 4,
  });
  // newPosts.value = postsData.sort((a: any, b: any) =>
  //   dayjs(a.insertDt).diff(dayjs(b.insertDt))
  // );
  newPosts.value = postsData;
});
</script>

<style scoped lang="scss">
// Popup
.backdrop {
  width: 100%;
  height: 100%;
  background-color: #0000008c;
  z-index: 999;
  position: absolute;
  top: 0;
  bottom: 0;
  overflow: hidden;
}

.popup-main {
  position: absolute;
  width: 304px;
  height: 404px;
  left: 50%;
  top: 80px;
  transform: translateX(-50%);
  color: #fff;
  font-size: 14px;
}

.popup-con {
  border-radius: 16px;
  overflow: hidden;
  max-width: 304px;
  height: 360px;
}

.popup-con img {
  width: 100%;
  height: 360px;
  object-fit: cover;
  border-radius: 16px;
  overflow: hidden;
}

.btn-popup {
  display: flex;
  justify-content: space-between;
  padding: 10px 0;
  align-items: center;
}

.btn-popup input {
  display: none;
}

.btn-pop-close {
  display: flex;
  align-items: center;
}

// Popup bullet
:deep(.swiper-pagination-bullet) {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  border: 1px solid #fff;
  background-color: transparent;
  opacity: 0.4;
  transition:
    opacity 0.3s,
    background-color 0.3s,
    border 0.3s;
}

:deep(.swiper-pagination-bullet.swiper-pagination-bullet-active) {
  background-color: #fff !important;
  border: none !important;
  opacity: 1 !important;
}
</style>
